// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#Flux360{transition:opacity .2s ease-in}.full-screen{height:100%!important;width:100%!important}.render-level{position:absolute;width:100%;height:100%}.ui-level{position:absolute;right:0;top:0;width:20%!important;height:100%!important}.title{font-size:1em!important;text-align:left!important;line-height:1.2!important;margin-bottom:0!important}", ""]);
// Exports
module.exports = exports;
